<template>
  <div style="padding: 30px">
    <el-form>
      <el-row>
        <el-col :span="8">
          <el-form-item label="标签名称：">
            <el-input v-model="labelName" clearable style="width: 200px" placeholder="请输入标签名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最后更新时间：">
            <el-date-picker
              v-model="labelTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <div class="">
            <el-button type="primary" @click="search()"> <i class="el-icon-search" style="margin-right: 5px"></i>查询 </el-button>
            <el-button @click="search('refresh')"> <i class="el-icon-refresh" style="margin-right: 5px"></i>重置 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-button type="primary" @click="addLabel" plain icon="el-icon-plus">新建标签</el-button>
    <dyTable :columns="columns" style="margin-top: 12px" :table-data="labelList" :total="total" :page-num="pageNo" :page-size="10" element-loading-text="加载中" @current-change="pageChange">
    </dyTable>

    <el-dialog title="标签信息" :visible.sync="infoDialog" width="500px">
      <el-form label-width="60px" :model="labelInfo" :rules="rules" ref="labelInfo">
        <el-form-item label="标签名称：" prop="name">
          <el-input style="width: 300px" v-model="labelInfo.name" maxlength="10" placeholder="请输入标签名称"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input style="width: 300px" type="textarea" v-model="labelInfo.notes" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div class="flex jc-fe">
        <el-button type="primary" plain @click="submitTs('labelInfo')">保存</el-button>
        <el-button plain @click="() => (this.infoDialog = false)">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="标签下的试题" :visible.sync="questionDialog" width="80%">
      <el-form>
        <el-row>
          <el-col :span="8">
            <el-form-item label="标题：">
              <el-input v-model="qLabelName" clearable placeholder="请输入标签名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="题型：">
              <el-select v-model="qTopicType" placeholder="请选择题型" clearable>
                <el-option label="单选题" :value="1"></el-option>
                <el-option label="多选题" :value="2"></el-option>
                <el-option label="判断题" :value="3"></el-option>
                <el-option label="填空题" :value="4"></el-option>
                <el-option label="主观题" :value="5"></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="试题分类：">
              <el-cascader v-model="qCategoryId" clearable :options="sortList" :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="最后更新时间：">
              <el-date-picker
                v-model="questionTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div class="flex jc-fe">
              <el-button type="primary" @click="qSearch()"> <i class="el-icon-search" style="margin-right: 5px"></i>查询 </el-button>
              <el-button @click="qSearch('refresh')"> <i class="el-icon-refresh" style="margin-right: 5px"></i>重置 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <dyTable
        :columns="qColumns"
        style="margin-top: 12px"
        tableHeight="300"
        :table-data="questionList"
        :total="qTotal"
        :page-num="qPageNo"
        :page-size="10"
        element-loading-text="加载中"
        @current-change="qPageChange"
      >
      </dyTable>
    </el-dialog>
  </div>
</template>

<script>
import dyTable from '@/components/common/dytable';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate, uniqueBy } from '@/utils/utils';
import { zgsourceAllCategory } from '@/api/index';
import { labelSave, getQuestionLabelList, delQuestionLabel, labelQueList } from '@/api/index2';
import { cleanObject } from '@/utils/utils';
import _ from 'lodash';
export default {
  name: 'classInfo',
  components: {
    dyTable,
  },
  computed: {},
  data() {
    return {
      labelName: '',
      labelTime: [],
      searchForm: {},
      columns: [],
      sortList: [],
      labelList: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      rules: {
        name: [{ required: true, message: '请输入标签名称', trigger: 'blur' }],
      },
      infoDialog: false,
      labelInfo: {
        name: '',
        notes: '',
      },

      questionDialog: false,
      qLabelName: '',
      qTopicType: null,
      qCategoryId: null,
      questionTime: [],
      qSearchForm: {},
      qColumns: [],

      questionLabel: {},
      questionList: [],
      qPageNo: 1,
      qPageSize: 10,
      qTotal: 0,
    };
  },
  created() {
    this.getList();
    this.getLiveCategory();
    this.columns = [
      {
        type: 'index',
        width: 60,
        title: '序号',
      },
      {
        key: 'name',
        title: '标签名称',
      },
      {
        key: 'bgUserName',
        title: '操作人',
      },
      {
        key: 'operatetime',
        title: '最后更新时间',
        render: ({ row }) => {
          return <div>{formatDate(new Date(row.operatetime), 'yyyy-MM-dd hh:mm:ss')}</div>;
        },
      },
      {
        key: '',
        title: '操作',
        render: ({ row }) => {
          return (
            <div>
              <el-link type='primary' class='ml12' onClick={() => this.questionDialogOpen(row)}>
                查看标签试题
              </el-link>
              <el-link type='primary' class='ml12' onClick={() => this.editLabel(row)}>
                编辑
              </el-link>
              <el-link type='danger' style='margin:0 12px' onClick={() => this.delLabel(row)}>
                删除
              </el-link>
            </div>
          );
        },
      },
    ];

    this.qColumns = [
      {
        type: 'index',
        width: 60,
        title: '序号',
      },
      {
        key: 'stem',
        title: '标题',
        showTooltip: true,
      },
      {
        key: 'labelName',
        title: '试题标签',
      },
      {
        key: 'categoryName',
        title: '试题分类',
      },

      {
        key: 'difficulty',
        title: '难度',
        render: ({ row }) => {
          return <div>{row.difficulty == 1 ? '简单' : row.difficulty == 2 ? '一般' : '困难'}</div>;
        },
      },
      {
        key: 'bgUserName',
        title: '操作人',
      },
      {
        key: 'operatetime',
        title: '最后更新时间',
        render: ({ row }) => {
          return <div>{formatDate(new Date(row.operatetime), 'yyyy-MM-dd hh:mm:ss')}</div>;
        },
      },
    ];
  },
  mounted() {},
  methods: {
    //获取所有直播分类(树型结构)
    getLiveCategory() {
      let info = {
        type: 2,
      };
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      zgsourceAllCategory(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('获取所有直播分类', ress);
          this.sortList = this.listFor(ress);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    listFor(arr) {
      let children = [];
      if (arr != null && arr != '' && arr != undefined) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i].childCourseCategory),
            });
          } else {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i].childCourseCategory),
            });
          }
        }
      } else {
        return;
      }
      return children;
    },
    pageChange(val) {
      this.pageNo = val;
      console.log('val :>> ', val);
      this.getList();
    },
    search(type) {
      this.searchForm = {
        name: this.labelName,
        from: this.labelTime ? this.labelTime[0] : null,
        to: this.labelTime ? this.labelTime[1] : null,
      };
      this.pageNo = 1;
      if (type == 'refresh') {
        this.labelName = '';
        this.labelTime = [];
        this.searchForm = {};
      }
      this.getList();
    },
    getList() {
      let param = {
        page: this.pageNo,
        pageSize: this.pageSize,
        ...this.searchForm,
      };
      console.log('123', param);
      getQuestionLabelList(cleanObject(param)).then((res) => {
        console.log('res', res);
        if (res.result == 1) {
          this.labelList = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
        this.infoDialog = false;
      });
    },
    addLabel() {
      this.labelInfo = {
        name: '',
        notes: '',
      };
      this.infoDialog = true;
    },
    editLabel(row) {
      this.labelInfo = row;
      this.infoDialog = true;
    },

    questionDialogOpen(row) {
      console.log('row', row);
      this.questionLabel = { ...row };
      this.qLabelName = '';
      this.qTopicType = '';
      this.qCategoryId = '';
      this.questionTime = [];
      this.qSearch();
      this.questionDialog = true;
    },
    qPageChange(val) {
      this.qPageNo = val;
      this.getQuestionList();
    },
    qSearch(type) {
      this.qSearchForm = {
        stem: this.qLabelName,
        topicType: this.qTopicType,
        categoryId: this.qCategoryId,
        from: this.questionTime ? this.questionTime[0] : null,
        to: this.questionTime ? this.questionTime[1] : null,
      };
      this.pageNo = 1;
      if (type == 'refresh') {
        this.qLabelName = '';
        this.qTopicType = null;
        this.qCategoryId = null;
        this.questionTime = [];
        this.qSearchForm = {};
      }
      this.getQuestionList();
    },
    getQuestionList() {
      let param = {
        label: this.questionLabel.id,
        page: this.qPageNo,
        pageSize: this.qPageSize,
        ...this.qSearchForm,
      };
      console.log('param :>> ', param);
      labelQueList(param).then((res) => {
        if (res.result == 1) {
          console.log('res :>> ', res);
          this.qTotal = res.data.total;
          this.questionList = res.data.list;
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    delLabel(row) {
      this.$confirm('您确定要删除标签吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let param = {
          id: row.id,
        };
        delQuestionLabel(param).then((res) => {
          if (res.result == 1) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.getList();
          } else {
            this.$message({
              type: 'warning',
              message: res.msg,
            });
          }
        });
      });
    },
    // 保存，防抖  一定时间内多次点击只执行最后一次
    submitTs: _.debounce(function (state) {
      this.labelClickSave(state);
    }, 300),
    labelClickSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('object :>> ', this.labelInfo);
          let param = {
            ...this.labelInfo,
          };
          labelSave(param).then((res) => {
            if (res.result == 1) {
              this.getList();
            } else {
              this.$message({
                showClose: true,
                message: res.msg,
                type: 'error',
              });
            }
            this.infoDialog = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
